"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextualTextStyle = void 0;
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var WithColorFilterSubscription_1 = __importDefault(require("../../WithColorFilterSubscription/WithColorFilterSubscription"));
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var StyleShortCutContainer_1 = __importDefault(require("Common/AtomicUI/StyleShortCutContainer/StyleShortCutContainer"));
var commonBlockOptions_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonBlockOptions");
var mobx_1 = require("mobx");
var ColorUtils_1 = require("Common/Utils/ColorUtils/ColorUtils");
var StyleServiceV2_1 = require("@CommonFrontendBackend/StyleServiceV2/StyleServiceV2");
var GetControls_1 = __importStar(require("./GetControls"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var ContextualTextStyle = (function (_super) {
    __extends(ContextualTextStyle, _super);
    function ContextualTextStyle() {
        var _a;
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.headingsTitleMappings = (_a = {},
            _a[commonTypes_1.TextElementType.H1] = "Heading",
            _a[commonTypes_1.TextElementType.H2] = "Subheading",
            _a[commonTypes_1.TextElementType.P] = "Paragraph",
            _a[commonTypes_1.TextElementType.Blockquote] = "Pull quote",
            _a[commonTypes_1.TextElementType.UnorderedListItem] = "List",
            _a);
        _this.handleSliderMouseUp = function () {
            _this.props.updateToolbarPosition();
        };
        _this.handleKeyPress = function (event) {
            if (event.key === "Enter" || event.key === "Tab") {
                _this.props.updateToolbarPosition();
                _this.props.reselectText();
                event.preventDefault();
                event.stopPropagation();
                if (event.target) {
                    event.target.blur();
                }
            }
        };
        _this.handleAlignmentChange = function (alignment) {
            var _a = _this, elementTypes = _a.elementTypes, props = _a.props;
            var blockStyleStore = props.blockStore.blockStyleStore;
            var parameters = {};
            elementTypes.forEach(function (elementType) {
                blockStyleStore.setElementStyle(elementType, __assign(__assign({}, blockStyleStore.getElementStyle(elementType)), { alignment: alignment }));
                parameters["block_styles_contextual_".concat(elementType, "_text_alignment")] = alignment;
            });
            _this.forceUpdate();
            setTimeout(_this.props.updateToolbarPosition);
            _this.props.telemetry.blockStylesContextualChanged(parameters);
        };
        _this.handleColorChange = function (color) {
            var _a = _this, elementTypes = _a.elementTypes, props = _a.props, controls = _a.controls;
            var blockStyleStore = props.blockStore.blockStyleStore;
            var parameters = {};
            elementTypes.forEach(function (type) {
                var newValue = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle(type));
                newValue.color.abs = color.value;
                newValue.color.themeIndex = color.themeIndex;
                if (!controls.showMarkerColor && type === commonTypes_1.TextElementType.UnorderedListItem) {
                    newValue.markerColor.abs = color.value;
                    newValue.markerColor.themeIndex = color.themeIndex;
                }
                blockStyleStore.setElementStyle(type, newValue);
                parameters["block_styles_contextual_".concat(type, "_text_color")] = (0, ColorUtils_1.getTelemetryColor)(color);
            });
            _this.props.telemetry.blockStylesContextualChanged(parameters);
        };
        _this.handleBarColorChange = function (color) {
            var props = _this.props;
            var blockStyleStore = props.blockStore.blockStyleStore;
            var newValue = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("blockQuote"));
            newValue.barColor = {
                abs: color.value,
                themeIndex: color.themeIndex,
            };
            blockStyleStore.setElementStyle("blockQuote", newValue);
        };
        _this.handleTextSizeChange = function (textSize) {
            var _a = _this, elementTypes = _a.elementTypes, props = _a.props;
            var blockStyleStore = props.blockStore.blockStyleStore;
            var parameters = {};
            var UnorderedListItem = commonTypes_1.TextElementType.UnorderedListItem, P = commonTypes_1.TextElementType.P, Blockquote = commonTypes_1.TextElementType.Blockquote;
            elementTypes.forEach(function (type) {
                if (type === UnorderedListItem) {
                    type = P;
                }
                var newValue = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle(type));
                newValue.size.abs = textSize;
                newValue.size.themeRef = null;
                blockStyleStore.setElementStyle(type, newValue);
                if (type === Blockquote) {
                    return;
                }
                parameters["block_styles_contextual_".concat(type, "_text_size")] = textSize;
            });
            _this.props.telemetry.blockStylesContextualChanged(parameters);
        };
        _this.handleDisplayQuoteIconToggle = function () {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var newValue = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("blockQuote"));
            newValue.displayQuoteIcon = !newValue.displayQuoteIcon;
            blockStyleStore.setElementStyle("blockQuote", newValue);
        };
        _this.handleMarkerColorChange = function (color) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var list = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("list"));
            list.markerColor = {
                abs: color.value,
                themeIndex: color.themeIndex,
            };
            blockStyleStore.setElementStyle("list", list);
        };
        _this.handleMarkerTypeChange = function (marker) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var list = (0, lodash_1.cloneDeep)(blockStyleStore.getElementStyle("list"));
            list.marker = marker;
            blockStyleStore.setElementStyle("list", list);
        };
        _this.renderMarkerColorComponent = function () {
            var _a = _this.props, filteredColors = _a.filteredColors, blockStore = _a.blockStore;
            var list = blockStore.blockStyleStore.model.list;
            return (react_1.default.createElement("div", { className: "style-shortcut__section" },
                react_1.default.createElement("div", { className: "style-shortcut__section-title label" }, "Marker Color"),
                react_1.default.createElement(ColorPalette_1.default, { presetColors: filteredColors, onColorChange: _this.handleMarkerColorChange, selectedColor: (0, GetBlockStyle_1.sanitizeColor)(list.markerColor, filteredColors), type: "content" })));
        };
        _this.renderMarkerTypeComponent = function () {
            var list = _this.props.blockStore.blockStyleStore.model.list;
            return (react_1.default.createElement("div", { className: "style-shortcut__section" },
                react_1.default.createElement(kaleidoscope_1.SegmentedControl, { theme: kaleidoscope_1.SegmentedControlTheme.Dark, label: "Marker Style", size: kaleidoscope_1.SegmentedControlSize.Medium, options: markerOptions, selectedValue: list.marker, onClickHandler: _this.handleMarkerTypeChange })));
        };
        _this.renderTextColorComponent = function () {
            var filteredColors = _this.props.filteredColors;
            return (react_1.default.createElement("div", { className: "style-shortcut__section" },
                react_1.default.createElement("div", { className: "style-shortcut__section-title label" }, "Text Color"),
                react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                    react_1.default.createElement(ColorPalette_1.default, { type: "content", presetColors: filteredColors, onColorChange: _this.handleColorChange, selectedColor: (0, GetBlockStyle_1.sanitizeColor)({ value: _this.selectedColor, themeIndex: _this.selectedThemeIndex }, filteredColors) }))));
        };
        _this.renderTextSizeComponent = function () {
            var _a = _this, elementTypes = _a.elementTypes, props = _a.props;
            var getElementStyle = props.blockStore.blockStyleStore.getElementStyle;
            var hasListItem = elementTypes[0] === commonTypes_1.TextElementType.UnorderedListItem;
            var elementType = hasListItem ? commonTypes_1.TextElementType.P : elementTypes[0];
            return (react_1.default.createElement("div", { className: "style-shortcut__section", onMouseUp: _this.handleSliderMouseUp },
                react_1.default.createElement(kaleidoscope_1.SliderInput, { theme: kaleidoscope_1.SliderTheme.Dark, initialInputValue: getElementStyle(elementType).size.abs, label: "text size", unit: "px", minimum: 14, handleValueChange: _this.handleTextSizeChange })));
        };
        _this.renderAlignmentComponent = function () {
            var _a = _this, elementTypes = _a.elementTypes, props = _a.props;
            var blockStyleStore = props.blockStore.blockStyleStore;
            return (react_1.default.createElement("div", { className: "style-shortcut__section style-shortcut__section--alignment" },
                react_1.default.createElement(kaleidoscope_1.SegmentedControl, { theme: kaleidoscope_1.SegmentedControlTheme.Dark, label: "Alignment", size: kaleidoscope_1.SegmentedControlSize.Medium, options: commonBlockOptions_1.alignmentOptions, selectedValue: (0, StyleServiceV2_1.getCombinedAlignment)(blockStyleStore.model, elementTypes), onClickHandler: _this.handleAlignmentChange })));
        };
        _this.renderBarColorComponent = function () {
            var _a = _this.props, filteredColors = _a.filteredColors, getElementStyle = _a.blockStore.blockStyleStore.getElementStyle;
            return (react_1.default.createElement("div", { className: "style-shortcut__section style-shortcut__section--bar-color" },
                react_1.default.createElement("div", { className: "style-shortcut__section-title label" }, "Bar Color"),
                react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                    react_1.default.createElement(ColorPalette_1.default, { type: "content", presetColors: filteredColors, onColorChange: _this.handleBarColorChange, selectedColor: (0, GetBlockStyle_1.sanitizeColor)(getElementStyle("blockQuote").barColor, filteredColors) }))));
        };
        _this.renderDisplayQuoteIconComponent = function () {
            var getElementStyle = _this.props.blockStore.blockStyleStore.getElementStyle;
            return (react_1.default.createElement(kaleidoscope_1.Toggle, { theme: kaleidoscope_2.ToggleTheme.Dark, label: "Display quote icon", value: getElementStyle("blockQuote").displayQuoteIcon, onChange: _this.handleDisplayQuoteIconToggle }));
        };
        _this.renderTitleComponent = function () {
            var elementTypes = _this.elementTypes;
            var firstElementType = elementTypes[0];
            if (isHeadingsTitleElementType(firstElementType)) {
                var selectedElementTitle = _this.headingsTitleMappings[firstElementType];
                return (react_1.default.createElement("div", { className: "style-shortcut__section" },
                    react_1.default.createElement("div", { className: "style-shortcut__section-title label contextual-style__title" },
                        selectedElementTitle,
                        " style")));
            }
            else {
                return null;
            }
        };
        return _this;
    }
    ContextualTextStyle.prototype.render = function () {
        var _a = this.controls, showTitle = _a.showTitle, showTextColor = _a.showTextColor, showTextSize = _a.showTextSize, showAlignment = _a.showAlignment, showBarColor = _a.showBarColor, showDisplayQuoteIcon = _a.showDisplayQuoteIcon, showMarkerColor = _a.showMarkerColor, showMarkerType = _a.showMarkerType;
        return (react_1.default.createElement(StyleShortCutContainer_1.default, { dark: true },
            react_1.default.createElement("div", { className: "contextual-style", onKeyDown: this.handleKeyPress },
                showTitle && this.renderTitleComponent(),
                showTextColor && this.renderTextColorComponent(),
                showTextSize && this.renderTextSizeComponent(),
                showAlignment && this.renderAlignmentComponent(),
                showBarColor && this.renderBarColorComponent(),
                showDisplayQuoteIcon && this.renderDisplayQuoteIconComponent(),
                showMarkerColor && this.renderMarkerColorComponent(),
                showMarkerType && this.renderMarkerTypeComponent())));
    };
    ContextualTextStyle.prototype.componentDidMount = function () {
        this.props.telemetry.blockStylesContextualViewed();
    };
    Object.defineProperty(ContextualTextStyle.prototype, "controls", {
        get: function () {
            return (0, GetControls_1.default)(this.elementTypes, this.hasOrderedListItem);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextualTextStyle.prototype, "elementTypes", {
        get: function () {
            return this.props.elementTypes.map(function (elementType) {
                return elementType === commonTypes_1.TextElementType.OrderedListItem ? commonTypes_1.TextElementType.UnorderedListItem : elementType;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextualTextStyle.prototype, "hasOrderedListItem", {
        get: function () {
            return this.props.elementTypes.includes(commonTypes_1.TextElementType.OrderedListItem);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextualTextStyle.prototype, "selectedThemeIndex", {
        get: function () {
            var blockStyleStore = this.props.blockStore.blockStyleStore;
            return (0, StyleServiceV2_1.getCombinedColorThemeIndex)(blockStyleStore.model, this.elementTypes);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextualTextStyle.prototype, "selectedColor", {
        get: function () {
            var blockStyleStore = this.props.blockStore.blockStyleStore;
            return (0, StyleServiceV2_1.getCombinedColor)(blockStyleStore.model, this.elementTypes);
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_a = typeof GetControls_1.IControlsMap !== "undefined" && GetControls_1.IControlsMap) === "function" ? _a : Object),
        __metadata("design:paramtypes", [])
    ], ContextualTextStyle.prototype, "controls", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], ContextualTextStyle.prototype, "elementTypes", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ContextualTextStyle.prototype, "hasOrderedListItem", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ContextualTextStyle.prototype, "selectedThemeIndex", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ContextualTextStyle.prototype, "selectedColor", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ContextualTextStyle.prototype, "handleColorChange", void 0);
    ContextualTextStyle = __decorate([
        mobx_react_1.observer
    ], ContextualTextStyle);
    return ContextualTextStyle;
}(react_1.default.Component));
exports.ContextualTextStyle = ContextualTextStyle;
var isHeadingsTitleElementType = function (type) {
    return [
        commonTypes_1.TextElementType.H1,
        commonTypes_1.TextElementType.H2,
        commonTypes_1.TextElementType.P,
        commonTypes_1.TextElementType.Blockquote,
        commonTypes_1.TextElementType.UnorderedListItem,
    ].includes(type);
};
exports.default = (0, WithColorFilterSubscription_1.default)(ContextualTextStyle);
var markerOptions = [
    {
        label: commonTypes_1.ListMarkerType.Circle,
        value: commonTypes_1.ListMarkerType.Circle,
        icon: react_1.default.createElement(icons_1.ListMarkerCircle, null),
    },
    {
        label: commonTypes_1.ListMarkerType.Square,
        value: commonTypes_1.ListMarkerType.Square,
        icon: react_1.default.createElement(icons_1.ListMarkerSquare, null),
    },
    {
        label: commonTypes_1.ListMarkerType.Dash,
        value: commonTypes_1.ListMarkerType.Dash,
        icon: react_1.default.createElement(icons_1.ListMarkerDash, null),
    },
];
